import React from "react";

const Close = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="9.152" height="9.129" viewBox="0 0 9.152 9.129">
			<path
				id="icons8-x"
				d="M6.934,6.313l-.693.693,3.86,3.86L6.219,14.756l.685.685,3.891-3.883,3.883,3.883.693-.693-3.883-3.883,3.86-3.86-.693-.693-3.86,3.86Z"
				transform="translate(-6.219 -6.313)"
				fill="#fd7a7a"
			/>
		</svg>
	);
};

export default Close;
